/* eslint-disable import/no-anonymous-default-export */
// @ts-nocheck
import React from 'react';
import ColumnAliasesSagas from './columnAliases/sagas';
import ColumnAliasesReducer from './columnAliases/reducer';
import ColumnAliases from './columnAliases/columnAliases';
import Settings from './settings';
import { isAppAliasSettingReadWrite } from 'models/user/selector';
import users from './accessControl/users';
import rowAccess from './accessControl/rowAccess';
import roles from './accessControl/roles';
import SettingsReducer from './reducer'
import SettingsSagas from './sagas'
import columnAliases from './columnAliases';


const AdminSettings = [
	{
		path: '/settings',
		key: 'key',
		componentId: 'adminSettings',
		component: (props) => <Settings  {...props} />,
		routes: [],
		importReducer: () => {
			return [SettingsReducer];
		},
		importSagas: () => {
			return [SettingsSagas];
		},
		title: 'Skulicity | Admin Settings',
		headerName: 'Admin Settings',
		name: 'Admin Settings',
		isEnabled: state => isAppAliasSettingReadWrite(state)
	},
	...columnAliases,
	...users,
	...rowAccess,
	...roles
];

export default AdminSettings;
